export default "__VITE_PUBLIC_ASSET__ef2581c3__"